import { AlertWidgetEventStruct } from "../alert-widget-event.struct";
import { WidgetEnum_Alert_Facade } from "../../../../enums";
export class AlertFacadeWidgetEventStruct extends AlertWidgetEventStruct {
  public event_alert_facade_widget_type: WidgetEnum_Alert_Facade;
}
